<template>
  <div class="page-max-width footer-max-width">
    <QHeader class="bg-primary text-white">
      <QToolbar>
        <QBtn flat round dense icon="icon-f-arrow-left" @click="goBack" />
        <QToolbarTitle>
          {{ $t("ETAB.PAGES.ADMIN_FOLDER.@ADMIN_FOLDER_STATUS_LABEL") }}
        </QToolbarTitle>
      </QToolbar>
    </QHeader>

    <QPageContainer>
      <QPage padding>
        <IconLabel heavy no-padding :label="$t('ETAB.PAGES.ADMIN_FOLDER.MENU.@ADMINISTRATIVE_INFOS')" icon="fad fa-pen-field" class="q-mb-lg" />
        <AdminFolder v-if="!loading" :etab-admin-folder="etabAdminFolder" @save-folder="saveFolder" />
        <template v-else>
          <div class="q-my-md">
            <QSkeleton animation="wave" type="text" />
          </div>
          <div class="q-my-md">
            <QSkeleton animation="wave" type="text" />
          </div>
          <div class="q-my-md">
            <QSkeleton animation="wave" type="text" />
          </div>
          <div class="row q-col-gutter-md q-mb-md">
            <div class="col-6">
              <QSkeleton animation="wave" type="text" />
            </div>
            <div class="col-6">
              <QSkeleton animation="wave" type="text" />
            </div>
          </div>
          <div class="q-my-md">
            <QSkeleton animation="wave" type="text" />
          </div>
        </template>
      </QPage>
    </QPageContainer>
  </div>
</template>

<script>
  import { NotificationsManager } from "@core/managers/notifications.manager";
  import { StatusBar } from "@core/plugins/mobile";
  import { ETAB_ROUTES } from "@etab/config";
  import { EtabAccountService } from "@core/services";
  import { EtabAdminFolderModel } from "@core/models";

  import AdminFolder from "@etab/components/account/AdminFolder.form.component.vue";

  export default {
    components: {
      AdminFolder,
    },
    data() {
      return {
        loading: false,
        etabAdminFolder: new EtabAdminFolderModel(),
      };
    },
    created() {
      this.getEtabAdminFolder();
    },
    methods: {
      async getEtabAdminFolder() {
        try {
          this.$_startGlobalLoading();
          this.loading = true;
          const adminFolderInfos = await EtabAccountService.getEtabAdminFolderInfos();
          this.etabAdminFolder = new EtabAdminFolderModel(adminFolderInfos);
        } catch (error) {
          NotificationsManager.error();
          throw error;
        } finally {
          this.loading = false;
          this.$_stopGlobalLoading();
        }
      },
      async saveFolder({ adminFolder }) {
        try {
          this.$_startGlobalLoading();
          this.loading = true;
          await EtabAccountService.updateEtabAdminFolderInfos({ adminFolder });
          NotificationsManager.success({ message: "SUCCESS.@SAVE_SUCCESS" });
          this.loading = false;
          this.$_stopGlobalLoading();
          this.goBack();
        } catch (error) {
          NotificationsManager.error();
          this.loading = false;
          this.$_stopGlobalLoading();
        }
      },
      goBack() {
        this.$router.push({ name: ETAB_ROUTES.account.adminFolderStatus.name }).catch((suppressedError) => {});
        StatusBar.setDefault();
      },
    },
  };
</script>
